module.exports = __webpack_public_path__ + "static/media/import.739379af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/import.svg
// module id = 2441
// module chunks = 0